import { createReducer } from '@reduxjs/toolkit'
import { PythonType } from 'interfaces/api/pythonTypes.interfaces'
import { createBuilder } from 'packages/redux-toolkit'

import { getAllPythonTypes } from './actions'

interface PythonTypesState {
  list: {
    loading: boolean
    items: PythonType[]
  }
}

const initialState: PythonTypesState = {
  list: {
    loading: false,
    items: [],
  },
}

export const pythonTypesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllPythonTypes.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllPythonTypes.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllPythonTypes.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload
    })
})
